// Leaf config file for workspace limit caps.
// The shared blocks mirror functions-common/src/config/workspaceLimitCaps.ts.
// WORKSPACE_LIMIT_HARD_CAPS is client-only.

import type { WorkspaceLimitKey } from '../types/schema'
import { CHECKLIST_INPUT_HARD_LIMITS } from '../utils/checklistLimits'

export const WORKSPACE_COUNT_LIMIT_KEYS = [
  'maxGoalsPerBoard',
  'maxTasksPerBoard',
  'maxTasksPerGoal',
  'maxSubtasksPerBoard',
  'maxSubtasksPerTask',
  'maxChecklistsPerBoard',
  'maxChecklistsPerContainer',
  'maxWorkspaceMembers',
  'maxPendingInvites',
  'maxEnabledDashboardViews',
  'maxAiPromptCharacters',
] as const

export type WorkspaceCountLimitKey = typeof WORKSPACE_COUNT_LIMIT_KEYS[number]

export const WORKSPACE_TIER_CAP_KEYS = [
  'maxGoalsPerBoard',
  'maxTasksPerBoard',
  'maxTasksPerGoal',
  'maxSubtasksPerBoard',
  'maxSubtasksPerTask',
  'maxChecklistsPerBoard',
  'maxChecklistsPerContainer',
] as const

export type WorkspaceTierCapKey = typeof WORKSPACE_TIER_CAP_KEYS[number]

export const WORKSPACE_COUNT_HARD_CAPS: Record<WorkspaceCountLimitKey, number> = {
  maxGoalsPerBoard: 100,
  maxTasksPerBoard: 50000,
  maxTasksPerGoal: 500,
  maxSubtasksPerBoard: 1250000,
  maxSubtasksPerTask: 25,
  maxChecklistsPerBoard: 1002000,
  maxChecklistsPerContainer: 20,
  maxWorkspaceMembers: 500,
  maxPendingInvites: 500,
  maxEnabledDashboardViews: 9,
  maxAiPromptCharacters: 5000,
}

export const BOARD_SCOPED_LIMIT_KEYS: readonly WorkspaceLimitKey[] = [
  'maxGoalsPerBoard',
  'maxTasksPerBoard',
  'maxSubtasksPerBoard',
  'maxChecklistsPerBoard',
]

export const WORKSPACE_LIMIT_HARD_CAPS: Record<WorkspaceLimitKey, number> = {
  ...WORKSPACE_COUNT_HARD_CAPS,
  ...CHECKLIST_INPUT_HARD_LIMITS,
} as Record<WorkspaceLimitKey, number>
